/**
 * Inline styles shared by every `FormDialog` body.
 *
 * A SEPARATE MODULE from `FormDialog.tsx` rather than exports beside
 * the component, because `react-refresh/only-export-components` is
 * right: a file that exports both a component and plain values loses
 * fast refresh for everything in it. These were module-local constants
 * in `Fleet/RobotDetailDrawer.tsx` until the door-override
 * attestation needed the same look; they live here so both dialogs
 * cannot drift apart.
 *
 * Inline rather than CSS classes to match what they replaced --
 * `ConfirmDialog.css` styles the shell only, and neither dialog body
 * has ever had a stylesheet of its own.
 */
import type { CSSProperties } from 'react';

// `ConfirmDialog.css` has no `:disabled` rule (its own confirm button
// is never disabled), so a gated confirm needs its affordance here.
export const DIALOG_DISABLED_BTN: CSSProperties = { opacity: 0.45, cursor: 'not-allowed' };

export const DIALOG_LIST: CSSProperties = {
  margin: '0 0 16px',
  paddingLeft: '18px',
  fontSize: '13px',
  lineHeight: 1.55,
  color: 'var(--nx-text)',
  display: 'flex',
  flexDirection: 'column',
  gap: '8px',
};

export const DIALOG_FIELDSET: CSSProperties = {
  border: '1px solid var(--nx-border)',
  borderRadius: '8px',
  padding: '10px 12px',
  margin: '0 0 16px',
  display: 'flex',
  flexDirection: 'column',
  gap: '10px',
};

export const DIALOG_LEGEND: CSSProperties = {
  padding: '0 6px',
  fontSize: '11px',
  letterSpacing: '0.14em',
  textTransform: 'uppercase',
  color: 'var(--nx-muted)',
};

export const DIALOG_OPTION: CSSProperties = {
  display: 'flex',
  alignItems: 'flex-start',
  gap: '8px',
  fontSize: '13px',
  cursor: 'pointer',
};

export const DIALOG_OPTION_LABEL: CSSProperties = { display: 'block', color: 'var(--nx-text)' };

export const DIALOG_OPTION_HINT: CSSProperties = {
  display: 'block',
  margin: 0,
  fontSize: '12px',
  color: 'var(--nx-muted)',
};
